import NavBar from "../../layout/NavBar";
import NavBarBot from "../../layout/NavBarBot";
import {
    Box, Container, ThemeProvider, Card, CardContent,
    Button, Typography
} from "@mui/material";
import { darkTheme } from "../../../theme/darkTheme";
import CrownIcon from "@mui/icons-material/WorkspacePremium";
import { premiumButtonSx } from "./components/premium/premiumData";
import PricingCards from "./components/premium/PricingCards";
import BenefitsListe from "./components/premium/BenefitsListe";

const PremiumAcc = () => {
    return (
        <>
            <ThemeProvider theme={darkTheme}>
                <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', pb: 4 }}>
                    <NavBar />
                    <Container maxWidth="lg" sx={{ pt: { md: 4 }, mt: 2 }}>

                        {/* Header Card mit Gold-Rand */}
                        <Card sx={{
                            mb: 3, borderRadius: "16px",
                            background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
                            border: "1px solid rgba(212, 175, 55, 0.25)"
                        }}>
                            <CardContent sx={{ p: { md: 2.5 }, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <CrownIcon sx={{ fontSize: 32, color: '#d4af37' }} />
                                <Box>
                                    <Typography variant="caption" sx={{ color: '#b38728', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.12em' }}>
                                        Premium
                                    </Typography>
                                    <Typography variant="h6" sx={{ color: '#f1f5f9', fontWeight: 600, lineHeight: 1.2 }}>
                                        Upgrade dein Training
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>

                        {/* Pricing Cards */}
                        <PricingCards />

                        {/* Benefits Liste */}
                        <BenefitsListe />

                        {/* Großer CTA Button */}
                        <Button onClick={() => alert("Bald verfügbar")} variant="contained" size="large" fullWidth sx={premiumButtonSx}>
                            Jetzt Premium sichern
                        </Button>

                    </Container>
                </Box>
            </ThemeProvider>
            <NavBarBot />
        </>
    );
};

export default PremiumAcc;
